type SiteElementBindTypes = "date" | "dateTime" | "dateTimeFormat" | "time" | "color" | "bool" | "telephone" | "email" | "image" | "timeSpan" | "timeSpan-short";

class SiteElementBind
    extends QueryElement<HTMLElement> {

    constructor(card: SiteCard, element: HTMLElement) {
        super(element, false);

        let path = this.getAttr('data-path');
        let type = this.getAttr('data-bindType') as SiteElementBindTypes | null;
        let showTitle = this.getAttr('data-title') == "true";
        let value = card.Model.get((path && SiteModel.splitPath(card.Model, path)) || []);
        let siteConfig = card.SiteConfig;

        if (showTitle)
            this.setAttr("title", value);
        
        if (value != null) {
            switch (type) {
                default:
                    break;
                case "telephone":
                    if (siteConfig.telephoneNumberSort == null)
                        break;
                    
                    let protocol = "";
                    switch(siteConfig.telephoneNumberSort)
                    {
                        case "CallTo":
                            protocol = "callto";
                            break;
                        case "Dial":
                            protocol = "dial";
                            break;
                        case "FaceTime":
                            protocol = "facetime";
                            break;
                        case "Skype":
                            protocol = "skype";
                            break;
                        case "Tel":
                            protocol = "tel";
                            break;
                    }
                    value = `<a href="${protocol}:${value}">${value}</a>`;
                    break;
                case "email":
                    value = `<a href="mailto:${value}">${value}</a>`;
                    break;
                case "bool":
                    value = value === true ? siteConfig.strings["yes"] : siteConfig.strings["no"];
                    break;
                case "dateTimeFormat":
                    let format = this.getAttr('data-dateTimeFormat') ?? "";
                    value = new QueryDate(new Date(value)).format(format, false);
                    break;
                case "date":
                    value = new QueryDate(new Date(value)).format("dd-mm-yyyy", false);
                    break;
                case "dateTime":
                    value = new QueryDate(new Date(value)).format("dd-mm-yyyy HH:MM:ss", false);
                    break;
                case "time":
                    value = new QueryDate(new Date(value)).format("dd-mm-yyyy HH:MM:ss", false);
                    break;
                case "image":
                    this.setAttr("src", value);
                    return;
                case "timeSpan":
                    let timeSpan = new TimeSpan(value);
                    value = timeSpan.toString();
                    break;
                case "timeSpan-short":
                    let timeSpanShort = new TimeSpan(value);
                    value = timeSpanShort.toStringShort();
                    break;
                case "color":
                    let style = this.style();
                    if (style && value) {
                        style.backgroundColor = value;
                    }
                    return;
            }

            this.setHtml(value);
        }
    }
}